export default {
  "flow": {
    "error": "تعذر إتمام العملية. حاول مجددًا.",
    "loadError": "تعذر تحميل المعلومات. حاول مجددًا.",
    "retry": "إعادة المحاولة",
    "loading": "جارٍ التحميل…",
    "buffering": "جارٍ تحميل البث…",
    "reconnecting": "جارٍ إعادة الاتصال بالبث…",
    "streamStopped": "توقف البث. حاول مجددًا.",
    "paymentError": "تعذر تأكيد الدفع. تحقق من سجل المشتريات قبل الدفع مجددًا.",
    "unavailable": "هذه العملية غير متاحة حاليًا. حاول لاحقًا."
  },
  "profile": {
    "eyebrow": "ATLAS · عالمك الخاص",
    "choose": "من يشاهد؟",
    "intro": "عالم من القصص ومساحة خاصة بك.",
    "manage": "إدارة الملفات الشخصية",
    "manageNote": "اختر ملفًا شخصيًا لتخصيص تجربة المشاهدة.",
    "edit": "تخصيص الملف الشخصي",
    "editNote": "اسمك وصورتك وتجربتك الخاصة.",
    "create": "عالم جديد ينتظرك",
    "createNote": "أنشئ ملفًا شخصيًا وابدأ قصتك.",
    "avatars": "اختر صورتك",
    "avatarsNote": "اختر صورة تعبّر عنك.",
    "avatar": "تغيير الصورة",
    "avatarEmpty": "تعذر تحميل الصور.",
    "retry": "إعادة المحاولة",
    "kidsNote": "مساحة مشاهدة مخصصة للأطفال.",
    "active": "الملف الشخصي الحالي",
    "kids": "ملف الأطفال",
    "profile": "ملف شخصي",
    "pinTitle": "تابع قصتك",
    "pinEditTitle": "فتح الملف الشخصي",
    "pinNote": "أدخل رمزك للدخول إلى عالمك الخاص.",
    "pinEditNote": "أدخل رمزك لتخصيص هذا الملف.",
    "pinHint": "رمز شخصي من 4 أرقام",
    "currentPin": "الرمز الحالي لهذا الملف",
    "partialCreate": "تم إنشاء الملف، لكن تعذر إكمال إعداداته. عدّل الملف للمتابعة.",
    "pinContinue": "متابعة",
    "pinLoading": "جارٍ تجهيز عالمك…",
    "pinError": "تعذرت المتابعة حاليًا. حاول مجددًا."
  },
  "filter": {
    "title": "ظهور المحتوى",
    "note": "اختر ما إذا كنت تريد إظهار المحتوى خارج باقاتك.",
    "label": "إظهار المحتوى خارج باقاتي",
    "description": "عند التفعيل يظهر المحتوى خارج باقاتك أيضًا. عند الإيقاف يظهر المحتوى المتاح لك فقط.",
    "on": "مفعّل",
    "off": "متوقف",
    "showingAll": "يظهر المحتوى خارج باقاتك. تتطلب مشاهدته الباقة أو حق الاستئجار المناسب.",
    "showingIncluded": "المحتوى خارج باقاتك مخفي.",
    "locked": "يدير مزود الخدمة هذا التفضيل. لا يمكن تغييره أثناء تطبيق السياسة المركزية.",
    "refresh": "تحديث الحالة",
    "saving": "جارٍ حفظ التفضيل…",
    "saved": "تم حفظ التفضيل. ستُحدّث قوائم المحتوى وفقًا له.",
    "saveError": "تعذر حفظ التفضيل أو تأكيده. حدّث الحالة قبل تغييره مجددًا."
  },
  "settings": {
    "eyebrow": "ATLAS · عالمك الخاص",
    "intro": "تجربة مشاهدة تناسبك.",
    "overview": "نظرة عامة",
    "personal": "أطلس الخاص بك",
    "personalNote": "كل تفضيلاتك في مكان واحد.",
    "groups": [
      "مشاهداتك",
      "تفضيلاتك",
      "حسابك"
    ],
    "notes": [
      "اختر قنواتك المفضلة وأدر قفل القنوات.",
      "شاهد محتوياتك المستأجرة والمشتراة.",
      "تصفح البرامج المحفوظة والتسجيلات القادمة.",
      "اختر إعدادات المشاهدة المناسبة لعائلتك.",
      "استخدم أطلس بلغتك المفضلة.",
      "عرض تفاصيل العضوية والاستخدام والتطبيق.",
      "اختر الإشعارات التي تريد تلقيها.",
      "عرض الأجهزة المتصلة بحسابك وإدارتها.",
      "عرض باقات الحساب وتواريخ صلاحيتها.",
      "اختر ما إذا كنت تريد إظهار المحتوى خارج باقاتك."
    ],
    "emptyPurchase": "لا توجد معاملات بعد",
    "emptyPurchaseNote": "ستظهر هنا معاملات الاستئجار والشراء للفترة المحددة.",
    "period": "الفترة",
    "loadError": "تعذر تحميل المعلومات. حاول مجددًا.",
    "retry": "إعادة المحاولة"
  },
  "rental": {
    "choose": "خيار الاستئجار",
    "confirmTitle": "تأكيد الاستئجار",
    "rentalFee": "سعر الاستئجار",
    "viewingPeriod": "مدة المشاهدة",
    "pinNext": "أدخل رمز ملفك الشخصي في الخطوة التالية للمتابعة.",
    "days": "أيام",
    "packages": "باقاتي",
    "unavailable": "باقتك لا تشمل هذا المحتوى.",
    "purchaseUnavailable": "الشراء الدائم غير متاح لهذا المحتوى حاليًا.",
    "changed": "تغير عرض الاستئجار أو انتهت صلاحيته. راجع الخيارات الحالية وأكد مجددًا.",
    "missing": "خيار الاستئجار هذا لم يعد متاحًا. تحقق من الخيارات الحالية.",
    "refresh": "تحديث الخيارات",
    "history": "سجل المعاملات",
    "inProgress": "توجد عملية استئجار قيد التنفيذ لهذا المحتوى. تحقق من سجل المعاملات قبل الدفع مجددًا.",
    "failed": "تعذر إتمام الاستئجار.",
    "billed": "أُضيفت رسوم الاستئجار إلى فاتورتك.",
    "demoBilled": "عملية تجريبية: أُضيفت رسوم الاستئجار إلى الفاتورة دون تحصيل مبلغ فعلي.",
    "completed": "اكتمل الاستئجار.",
    "accessReady": "المحتوى جاهز للمشاهدة. لم تُحصّل رسوم إضافية.",
    "contextChanged": "تغيرت الجلسة أو الملف الشخصي. تحقق من سجل معاملات الحساب الذي بدأت منه قبل الاستئجار مجددًا.",
    "invalidOffer": "معلومات الاستئجار غير مكتملة. حدّث الخيارات.",
    "end": "تنتهي حقوق عرض هذا المحتوى في:",
    "consent": "أوافق على انتهاء مدة الاستئجار في هذا التاريخ.",
    "emptyPackages": "لا توجد باقات نشطة.",
    "packageNote": "عرض باقات الحساب وتواريخ صلاحيتها.",
    "active": "نشطة",
    "inactive": "غير نشطة",
    "suspended": "معلقة",
    "expired": "منتهية الصلاحية",
    "canceled": "ملغاة",
    "start": "البداية",
    "endDate": "النهاية"
  },
  "version": {
    "username": "اسم المستخدم",
    "phone": "الهاتف",
    "plan": "الباقة",
    "hide": "إخفاء التفاصيل",
    "details": "تفاصيل الباقة",
    "storage": "مساحة التسجيل"
  }
};
